"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { FlickrRoutedPage } from './deskUi/FlickrRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function FlickrSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={FlickrRoutedPage} Loading={MsgDeskLoading} />
}
